import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-list.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-list.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output, ViewChild } from "@angular/core";
import { BehaviorSubject, from, Subject } from "rxjs";
import { filter, take, takeUntil } from "rxjs/operators";
import * as RecipientListConstants from "./recipient-list.constants";
import { RecipientsHeadingLookup } from "./recipient-list.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { AddNewRecipientComponent } from "../recipient-select/shared/add-new-recipient/add-new-recipient.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EditRecipientModalFormComponent } from "./edit-recipient-modal-form/edit-recipient-modal-form.component";
import { FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RecipientListFilterComponent } from "./recipient-list-filter/recipient-list-filter.component";
import { RecipientListService } from "./shared/recipient-list.service";
import Query from "@arcgis/core/rest/support/Query";
import { MapTools } from "../../../map/shared/map.tools";
import { MapService } from "../../../map/shared/map.service";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
let RecipientListComponent = class RecipientListComponent {
    appController;
    changeDetectorRef;
    recipientListService;
    mapTools;
    mapService;
    modalService;
    _destroy$ = new Subject();
    filter;
    disableFilter;
    disableTableColumnFilter = false;
    label;
    disableAdd;
    recipientGroupsToFilterBy;
    disableEdit = false;
    showRecipientListButtons = true;
    showRecipientTypeColumn;
    jobId;
    recipientSelector = "Selector";
    inViewApplication = false;
    tableSelection = [];
    stepMetaRecipientGroups = [];
    showFilter;
    tableMapper;
    recipientsArray = new BehaviorSubject([]);
    removeBtnTextPlaceholder = SharedConstants.REMOVE_LABEL;
    editBtnTextPlaceholder = SharedConstants.EDIT_LABEL;
    addBtnTextPlaceholder = SharedConstants.ADD_LABEL;
    recipientListForm;
    configurableLabel = RecipientListConstants.DEFAULT_RECIPIENT_LABEL;
    hideAddButton = true;
    hideEditButton = true;
    showMap = false;
    mapComponent;
    recipientAlreadyAddedErrorMsg = RecipientListConstants.RECIPIENT_ALREADY_ADDED_MESSAGE;
    defaultRadioButtonSelection = RecipientListConstants.DEFAULT_RADIO_BUTTON_SELECTION;
    modalBodyOptions = {
        size: "xl",
        centered: true,
        backdrop: "static"
    };
    requiredFields;
    sketch;
    selectedGraphic;
    propertyOwnersLayer;
    componentLoaded = false;
    recipientListSubscription;
    requiredFieldsSubscription;
    filteredRecipientsSubscription;
    emitSelectedRecipients = new EventEmitter();
    constructor(appController, changeDetectorRef, recipientListService, mapTools, mapService, modalService) {
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
        this.recipientListService = recipientListService;
        this.mapTools = mapTools;
        this.mapService = mapService;
        this.modalService = modalService;
    }
    get value() {
        return this.recipientListForm.value;
    }
    set value(recipients) {
        if (recipients.length !== 0 && !recipients.hasOwnProperty("recipients")) {
            const recipientsArray = [];
            recipients.forEach((recipient) => {
                if (recipient.hasOwnProperty("overrideGroup")) {
                    recipient.groupsStringArray = this.stepMetaRecipientGroups.map(group => group.groupName);
                    recipient.groups = this.stepMetaRecipientGroups.map(group => {
                        return { groupName: group.groupName, groupType: group.groupType };
                    });
                    recipientsArray.push(recipient);
                }
                this.addRecipientClicked(recipient);
            });
        }
        if (recipients.hasOwnProperty("recipients")) {
            const x = recipients.recipients;
            if (x) {
                x.forEach(recipient => {
                    if (recipient.hasOwnProperty("overrideGroup")) {
                        recipient.groupsStringArray = this.stepMetaRecipientGroups.map(group => group.groupName);
                        recipient.groups = this.stepMetaRecipientGroups.map(group => {
                            return { groupName: group.groupName, groupType: group.groupType };
                        });
                    }
                    this.addRecipientClicked(recipient);
                });
            }
        }
    }
    ngOnInit() {
        this.initializeColumnToObjectMapping();
        this.stepMetaRecipientGroups = this.recipientListService.checkStepMetaRecipientGroups(this.recipientGroupsToFilterBy);
        this.requiredFieldsSubscription = this.recipientListService.requiredFields.subscribe((fields) => {
            this.requiredFields = fields;
        });
        this.showOrHideRecipientFilter();
        this.initializeForm();
        this.recipientListService.emitRecipientList.pipe(take(1)).subscribe(x => {
            this.addAllRecipientsClicked(x);
        });
    }
    ngOnChanges(changes) {
        if (this.inViewApplication) {
            if (changes.hasOwnProperty("recipientGroupsToFilterBy")
                && changes.recipientGroupsToFilterBy.currentValue &&
                changes.recipientGroupsToFilterBy.currentValue.length > 0) {
                this.recipientGroupsToFilterBy = changes.recipientGroupsToFilterBy.currentValue;
                this.stepMetaRecipientGroups = this.recipientGroupsToFilterBy;
                this.changeDetectorRef.detectChanges();
            }
        }
    }
    recipientRadioButtonClicked(recipient) {
        if (recipient !== undefined) {
            this.recipientsArray.pipe(takeUntil(this._destroy$), take(1)).subscribe(recipientsAlreadyInTheTable => {
                // tslint:disable-next-line:prefer-for-of
                for (let i = 0; i < recipientsAlreadyInTheTable.length; i++) {
                    if (recipient === recipientsAlreadyInTheTable[i]) {
                        recipientsAlreadyInTheTable[i].emailField = recipient.emailField;
                    }
                }
                const newArr = [...recipientsAlreadyInTheTable];
                this.updateRecipientsFormControl(newArr);
                this.recipientsArray.next(newArr);
            });
        }
    }
    ngAfterViewInit() {
        this.componentLoaded = true;
        if (this.recipientSelector === "Map") {
            this.mapLoaded();
        }
    }
    mapLoaded() {
        if (this.componentLoaded) {
            this.sketch = this.mapTools.getMapTool("drawTool");
            this.mapTools.expandWidget("drawTool");
            this.sketch.on("create", (event) => {
                if (event.state === "complete") {
                    this.selectedGraphic = event.graphic;
                    this.propertyOwnersLayer = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner").layer;
                    const graveQuery = new Query();
                    graveQuery.spatialRelationship = "intersects";
                    graveQuery.returnGeometry = true;
                    graveQuery.geometry = this.selectedGraphic.geometry;
                    graveQuery.outFields = ["*"];
                    this.propertyOwnersLayer.queryFeatures(graveQuery).then((propertyFeatureSet) => {
                        if (propertyFeatureSet.features.length > 0) {
                            const recipients = [];
                            propertyFeatureSet.features.forEach((feature) => {
                                const attributeData = this.buildRecipientDataForTable(feature.attributes);
                                const recipient = this.removeUnwantedProperties(attributeData);
                                recipients.push(recipient);
                            });
                            this.appendRecipient(recipients);
                        }
                        if (this.selectedGraphic !== null) {
                            this.mapTools.sketchGraphicsLayer.remove(this.selectedGraphic);
                        }
                    }, (error) => {
                        this.appController.showMessage(error.message, AlertType.Error);
                    });
                }
            });
        }
    }
    addRecipientClicked(recipient) {
        if (recipient !== undefined) {
            let savedRecipient;
            if (recipient.id === 0) {
                savedRecipient = this.generateTempId(recipient);
            }
            else {
                savedRecipient = recipient;
            }
            const recipientsAlreadyInTheTable = this.recipientsArray.getValue();
            let recipientAlreadyAdded = false;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < recipientsAlreadyInTheTable.length; i++) {
                if ((savedRecipient.id !== 0) && savedRecipient.id === recipientsAlreadyInTheTable[i].id && savedRecipient.id !== undefined) {
                    recipientAlreadyAdded = true;
                    break;
                }
            }
            if (!recipientAlreadyAdded) {
                this.addRecipientsToRecipientsTable(savedRecipient, recipientsAlreadyInTheTable);
            }
            else {
                this.handleRecipientAlreadyAdded();
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    addAllRecipientsClicked(recipients) {
        this.recipientsArray.pipe(takeUntil(this._destroy$), take(1)).subscribe((recipientsAlreadyOnTheTable) => {
            if (this.recipientsArray.getValue().length === 0) {
                const newArr = [...recipientsAlreadyOnTheTable];
                recipients.forEach((recipient) => {
                    recipient.emailField = this.defaultRadioButtonSelection;
                    recipient.groupsStringArray = recipient.groups.map(group => group.groupName);
                    // recipient.groups = this.stepMetaRecipientGroups.map(group => {
                    //   return {groupName: group.groupName, groupType: group.groupType};
                    // });
                    newArr.push(recipient);
                });
                this.recipientsArray.next(newArr);
                this.onChange({ recipients: newArr });
            }
            else {
                const newArr = [...recipientsAlreadyOnTheTable];
                recipients.forEach(recipient => {
                    if (recipientsAlreadyOnTheTable.indexOf(recipient) < 0) {
                        recipient.emailField = this.defaultRadioButtonSelection;
                        recipient.groupsStringArray = recipient.groups.map(group => group.groupName);
                        // recipient.groups = this.stepMetaRecipientGroups.map(group => {
                        //   return {groupName: group.groupName, groupType: group.groupType};
                        // });
                        newArr.push(recipient);
                    }
                    this.recipientListForm.get("recipients").setValue(this.recipientsArray.value);
                    // this.updateRecipientsFormControl(newArr);
                    this.recipientsArray.next(newArr);
                    this.onChange({ recipients: newArr });
                });
            }
        });
    }
    arrayReturned(array) {
        this.tableSelection = array;
        this.emitSelectedRecipients.emit(this.tableSelection);
    }
    onBtnDeleteClicked() {
        if (this.tableSelection.length > 0) {
            const recipientsArray = from(this.recipientsArray.getValue());
            const filteredRecipients = recipientsArray.pipe(filter((recipient) => {
                if (this.tableSelection.indexOf(recipient) < 0) {
                    return true;
                }
            }));
            const newRecipientsArray = [];
            this.filteredRecipientsSubscription = filteredRecipients.subscribe(recipient => {
                newRecipientsArray.push(recipient);
            });
            this.updateRecipientsFormControl(newRecipientsArray);
            this.recipientsArray.next(newRecipientsArray);
            this.tableSelection = [];
        }
        else {
            this.appController.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
        }
    }
    onBtnEditClicked() {
        if (this.tableSelection === undefined || this.tableSelection.length === 0) {
            this.appController.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appController.showMessage(SharedConstants.MORE_THAN_ONE_SELECTED, AlertType.Warning);
            return;
        }
        this.openEditRecipientModalDialog();
    }
    onBtnAddClicked() {
        if (this.recipientGroupsToFilterBy.length == 0) {
            this.appController.showMessage(RecipientListConstants.NO_GROUPS_DETECTED_ERR_MSG, AlertType.Warning);
            return;
        }
        const dialogRef = this.modalService.open(AddNewRecipientComponent, this.modalBodyOptions);
        dialogRef.componentInstance.title = this.label;
        dialogRef.componentInstance.groupsFromMetaData = this.stepMetaRecipientGroups;
        dialogRef.componentInstance.jobId = this.jobId ? +this.jobId : null;
        if (this.recipientGroupsToFilterBy.length > 1) {
            dialogRef.componentInstance.showRecipientsGroupsDropdown = true;
        }
        else {
            dialogRef.componentInstance.showRecipientsGroupsDropdown = false;
        }
        dialogRef.result.then((newRecipient) => {
            if (newRecipient) {
                this.addRecipientClicked(newRecipient);
            }
        });
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(recipients) {
        if (recipients) {
            this.value = recipients;
        }
        if (recipients === null) {
            this.recipientsArray.next([]); // NB: I added this lign to fix the reset
            this.recipientListForm.reset();
            if (this.filter && this.showFilter &&
                this.recipientListForm.pristine && !this.recipientListForm.touched) {
                this.tableSelection = [];
                this.recipientsArray.next([]);
                this.filter.resetForm();
                this.changeDetectorRef.detectChanges();
            }
        }
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    validate(_) {
        return this.recipientListForm.valid ? null : { recipientList: { valid: false } };
    }
    addRecipientFromFilter($event) {
        const recipient = $event;
        recipient.groupsStringArray = this.stepMetaRecipientGroups.map(group => group.groupName);
        recipient.groups = recipient.groups.map(group => {
            return {
                id: group.id,
                recipientId: group.recipientId,
                groupName: group.groupName,
                groupType: group.groupType
            };
        });
        this.value = [recipient];
    }
    openEditRecipientModalDialog() {
        const dialog = this.modalService.open(EditRecipientModalFormComponent, this.modalBodyOptions);
        dialog.componentInstance.recipientToEdit = this.tableSelection[0];
        dialog.componentInstance.groupsFromMetaData = this.stepMetaRecipientGroups;
        dialog.componentInstance.title = this.label;
        dialog.result.then((newRecipient) => {
            if (newRecipient) {
                this.onBtnDeleteClicked();
                this.addRecipientClicked(newRecipient);
            }
        });
    }
    showOrHideRecipientFilter() {
        this.showFilter = !this.disableFilter;
        this.hideEditButton = this.disableEdit;
        this.hideAddButton = this.disableAdd;
        if (this.recipientSelector === "Map") {
            // always hides the filter if the map is shown
            this.showMap = true;
            this.showFilter = false;
        }
        if (this.showFilter) {
            const label = this.label;
            this.configurableLabel = `Select ${label}`[0].toUpperCase() + `Select ${label}`.substr(1).toLowerCase();
        }
    }
    ;
    initializeColumnToObjectMapping() {
        this.tableMapper = RecipientsHeadingLookup;
    }
    updateRecipientsFormControl(recipients) {
        if (recipients) {
            this.recipientListForm.get("recipients").setValue(recipients);
        }
    }
    initializeForm() {
        this.recipientListForm = new FormGroup({
            recipients: new FormControl(null)
        });
        this.recipientListSubscription = this.recipientListForm.valueChanges.subscribe((value) => {
            this.onChange(value);
            this.onTouched();
        });
    }
    setRecipient(recipient) {
        delete recipient.setRecipient;
        this.recipientsArray.next([recipient]);
        this.recipientListForm.get("recipients").setValue([recipient]);
        this.onChange({ recipients: [recipient] });
        this.changeDetectorRef.detectChanges();
    }
    appendRecipient(recipientsArray) {
        this.recipientsArray.next(recipientsArray);
        this.recipientListForm.get("recipients").setValue(this.recipientsArray.value);
        this.onChange({ recipients: recipientsArray });
        this.changeDetectorRef.detectChanges();
    }
    addRecipientsToRecipientsTable(recipient, recipientsAlreadyInTheTable) {
        recipient.emailField = this.defaultRadioButtonSelection;
        const newArr = [...recipientsAlreadyInTheTable, recipient];
        if (newArr.length > 0) {
            newArr.forEach((recipientToBeSaved) => {
                if (recipientToBeSaved.hasOwnProperty("overrideGroup"))
                    delete recipient.overrideGroup;
                if (recipientToBeSaved.hasOwnProperty("setRecipient"))
                    delete recipient.setRecipient;
            });
        }
        this.appendRecipient(newArr);
        this.onTouched();
    }
    handleRecipientAlreadyAdded() {
        this.recipientListForm.get("recipients").setValue(this.recipientsArray.value);
        this.onTouched();
    }
    buildRecipientDataForTable(attributes) {
        // builds up a recipient object from the attribute data
        return {
            id: 0,
            jobId: this.jobId ? Number(this.jobId) : null,
            moduleId: this.appController.selectedModuleID ? +this.appController.selectedModuleID : null,
            name: attributes.Name,
            surname: attributes.Surname,
            telephone: attributes.Telephone,
            email: attributes.Email,
            defaultCommunicationMethod: attributes.DefaultCommunicationMethod,
            postalAddress: attributes.PostalAddress,
            designation: attributes.Designation,
            organisation: attributes.ORGANISATION,
            clientVatNumber: attributes?.ClientVatNumber,
            streetAddress: attributes.StreetAddress,
            homePhone: attributes.Homephone,
            idNumber: attributes.IDNumber,
            organisationRegistrationNumber: attributes.OrganisationRegistrationNumber,
            representative: attributes.Representative,
            fax: attributes.Fax,
            cellphone: attributes.Cellphone,
            streetSuburb: attributes.StreetSuburb,
            streetCity: attributes.StreetCity,
            streetProvince: attributes.StreetProvince,
            streetCode: attributes.StreetCode,
            postalSuburb: attributes.StreetSuburb,
            postalCity: attributes.PostalCity,
            postalProvince: attributes.PostalProvince,
            postalCode: attributes.PostalCode,
            postalCountry: attributes.PostalCountry,
            streetCountry: attributes.StreetCountry,
            professionalBody: attributes.ProfessionalBody,
            professionalBodyRegNum: attributes.ProfessionalBodyRegistrationNumber,
            groups: this.stepMetaRecipientGroups
        };
    }
    removeUnwantedProperties(attributeData) {
        // removes properties that cant be saved in the recipient endpoint
        const recipient = attributeData;
        recipient.groups.forEach(group => {
            if (group.hasOwnProperty("requiredFields")) {
                delete group.requiredFields;
            }
        });
        return recipient;
    }
    generateTempId(recipient) {
        let uuidValue = "";
        for (let k = 0; k < 32; k++) {
            // tslint:disable-next-line:no-bitwise
            const randomValue = Math.random() * 16 | 0;
            if (k === 8 || k === 12 || k === 16 || k === 20) {
                uuidValue += "-";
            }
            // tslint:disable-next-line:no-bitwise
            uuidValue += (k === 12 ? 4 : (k === 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
            recipient.id = uuidValue;
        }
        return recipient;
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RecipientListService },
        { type: MapTools },
        { type: MapService },
        { type: NgbModal }
    ];
    static propDecorators = {
        filter: [{ type: ViewChild, args: [RecipientListFilterComponent,] }],
        disableFilter: [{ type: Input }],
        disableTableColumnFilter: [{ type: Input }],
        label: [{ type: Input }],
        disableAdd: [{ type: Input }],
        recipientGroupsToFilterBy: [{ type: Input }],
        disableEdit: [{ type: Input }],
        showRecipientListButtons: [{ type: Input }],
        showRecipientTypeColumn: [{ type: Input }],
        jobId: [{ type: Input }],
        recipientSelector: [{ type: Input }],
        inViewApplication: [{ type: Input }],
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }],
        emitSelectedRecipients: [{ type: Output }]
    };
};
RecipientListComponent = __decorate([
    Component({
        selector: "app-recipient-list",
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RecipientListComponent),
                multi: true,
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => RecipientListComponent),
                multi: true,
            },
        ],
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], RecipientListComponent);
export { RecipientListComponent };
